export default __webpack_public_path__ + "static/media/zoom-in.a6788ff7.png";